module.exports = __webpack_public_path__ + "static/media/sh.4ef811b7.svg";